import { render, staticRenderFns } from "./HdCompanyDetail.vue?vue&type=template&id=6a30a8d8&scoped=true"
import script from "./HdCompanyDetail.vue?vue&type=script&lang=js"
export * from "./HdCompanyDetail.vue?vue&type=script&lang=js"
import style0 from "./HdCompanyDetail.vue?vue&type=style&index=0&id=6a30a8d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a30a8d8",
  null
  
)

export default component.exports